import React from 'react';
import { Box, Container, Heading, Button, Stack, Link } from '@chakra-ui/react';
import sarah from '@/assets/images/webp/sarah.webp';
import { TFunction } from 'i18next';
import { Link as RouterLink } from 'react-router-dom';
import { CONSOLE_ROOT_PATH } from '@/routes/path';

interface TopBannerProps {
  t: TFunction;
  language: 'en' | 'jp';
}

const TopBanner: React.VFC<TopBannerProps> = ({ t, language }) => {
  return (
    <Box background="white" backgroundImage={sarah} bgPos="top" bgSize="cover" h="690px" mb="8">
      <Container h="100%" maxW="container.xl">
        <Stack align={['center', 'flex-start']} h="100%" justify="center">
          <Box
            background="rgba(0,0,0,0.3)"
            color="white"
            p="4"
            textAlign="left"
            w={['100%', '100%', 'fit-content']}>
            {language === 'jp' ? (
              <>
                <Heading as="h1" mb="4" size="3xl">
                  理想のARを、速く、簡単に
                </Heading>
                <Heading as="h2" mb="4" size="md">
                  高精度・高速なVPSとマルチプレイヤーを搭載。
                </Heading>
                <Heading as="h2" mb="4" size="md">
                  Pretiaを使って、アイディアを&quot;現実&quot;にしましょう。
                </Heading>
              </>
            ) : (
              <>
                <Heading as="h1" mb="4" size="3xl">
                  AR Development
                </Heading>
                <Heading as="h1" mb="4" size="3xl">
                  Made Easy
                </Heading>
              </>
            )}

            {/* <Link as={RouterLink} target="_blank" to={CONSOLE_ROOT_PATH} variant="no-decoration">
              <Button colorScheme="blue" rounded="full" variant="invert-solid" w="150px">
                {t('get_started')}
              </Button>
            </Link> */}
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default TopBanner;

// Pretiaで作る
// 次元を越えるAR体験
// Pretiaを使えば精度の高いARコンテンツが
// 手軽に作れます。（もっといいメッセージが必要）
